var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpWordmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1984.3 521.2",
    style: {
      enableBackground: "new 0 0 1984.3 521.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.4,
    y: 152.6,
    className: "st0",
    width: 74.2,
    height: 254.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M754,152.6h-99.7l-70.2,70.2c-25.1,25.1-26.7,65.5-2.7,92.2l81.6,92.2h96.9L638.2,278.9 c-4.3-4.3-3.9-11.4,0.4-15.7L754,152.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 21.8,
    className: "st0",
    width: 74.2,
    height: 385.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M972.1,152.6l-1.2,20.4c-0.4,4.7-5.9,7.1-9.4,3.5c-18.8-18-43.9-31-77.7-31c-66.3,0-126.7,53.8-126.7,134.6 s60.4,134.6,126.7,134.6c33.7,0,59.3-12.9,77.7-31c3.5-3.5,9.4-1.2,9.4,3.5l1.2,19.6h67.1V152.2h-67.1V152.6z M898.4,346.8 c-31.4,0-67.1-25.1-67.1-66.7c0-41.2,35.7-66.7,67.1-66.7c31.4,0,67.1,25.1,67.1,66.7S929.7,346.8,898.4,346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1594.1,152.6l-1.2,20.4c-0.4,4.7-5.9,7.1-9.4,3.5c-18.8-18-43.9-31-77.7-31c-66.3,0-126.7,53.8-126.7,134.6 s60.4,134.6,126.7,134.6c33.7,0,59.3-12.9,77.7-31c3.5-3.5,9.4-1.2,9.4,3.5l1.2,19.6h67.1V152.2h-67.1V152.6z M1520.3,346.8 c-31.4,0-67.1-25.1-67.1-66.7c0-41.2,35.7-66.7,67.1-66.7s67.1,25.1,67.1,66.7S1551.7,346.8,1520.3,346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1887.6,152.6L1832.6,306c-2,5.1-8.6,5.1-10.6,0l-55.7-153.4h-76.9l98.9,249.2c1.2,3.1,1.2,7.1,0,10.2 l-37.3,94.2h74.2l139.7-353.5H1887.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1093,21.1v74.2l160.9,0.8c25.9,0,46.7,20.8,46.7,46.7l0,0c0,25.9-20.8,46.7-46.7,46.7h-70.2 c-43.6,0-78.5,35.3-78.5,78.5v138.9h76.5v-124c0-10.6,8.6-19.2,19.2-19.2h55.3c66.7,0,121.2-54.1,121.2-121.2l0,0 c0-66.7-54.1-121.2-121.2-121.2H1093z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,21.1v74.2l160.9,0.8c25.9,0,46.7,20.8,46.7,46.7l0,0c0,25.9-20.8,46.7-46.7,46.7h-70.2 c-43.6,0-78.5,35.3-78.5,78.5v138.9h76.5v-124c0-10.6,8.6-19.2,19.2-19.2h55.3c66.7,0,121.2-54.1,121.2-121.2l0,0 c0-66.7-54.1-121.2-121.2-121.2H19.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpWordmarkWhite);
export default __webpack_public_path__ + "static/media/PP_wordmark_white.f282153bfe6d7ec6b4efcefc1f75c3c6.svg";
export { ForwardRef as ReactComponent };